<!-- PROGRESS BAR -->
<fuse-progress-bar></fuse-progress-bar>
<!-- / PROGRESS BAR -->

<!-- MAIN LAYOUT -->
<app-main-layout></app-main-layout>
<!-- / MAIN LAYOUT -->